var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1993 3.94418L15.9591 7.49288C16.1991 7.98687 16.839 8.4607 17.379 8.55143L20.5686 9.08575C22.6084 9.42853 23.0884 10.9206 21.6185 12.3925L19.1388 14.8927C18.7188 15.3161 18.4889 16.1327 18.6188 16.7175L19.3288 19.8125C19.8887 22.2623 18.5988 23.21 16.4491 21.9296L13.4594 20.1452C12.9195 19.8226 12.0296 19.8226 11.4796 20.1452L8.48995 21.9296C6.35018 23.21 5.05033 22.2522 5.61027 19.8125L6.32019 16.7175C6.45017 16.1327 6.2202 15.3161 5.80024 14.8927L3.32052 12.3925C1.86068 10.9206 2.33063 9.42853 4.3704 9.08575L7.56005 8.55143C8.08999 8.4607 8.72992 7.98687 8.96989 7.49288L10.7297 3.94418C11.6896 2.01861 13.2494 2.01861 14.1993 3.94418Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.e7d19cc55589d063cb56bb6f417c7136.svg";
export { ForwardRef as ReactComponent };